import { Link } from 'react-router';
import { ArrowLeft } from 'lucide-react';
import MovoFleetLogo from '@/shared/ui/branding/MovoFleetLogo';
import { secondaryButtonClass } from '@/shared/ui/formClasses';

export default function DemoRequestHeader() {
  return (
    <header className="mb-8 flex flex-col gap-4 rounded-3xl border border-default bg-default px-5 py-4 shadow-resting md:flex-row md:items-center md:justify-between">
      <div className="flex min-w-0 items-center gap-3">
        <MovoFleetLogo variant="form" className="shrink-0" />
        <p className="text-sm text-strong">Questionario demo e qualificazione</p>
      </div>
      <nav className="flex flex-col gap-2 sm:flex-row">
        <Link to="/login" className={secondaryButtonClass}>
          Accedi
        </Link>
        <Link to="/" className={secondaryButtonClass}>
          <ArrowLeft aria-hidden className="size-3.5" />
          Torna alla home
        </Link>
      </nav>
    </header>
  );
}
